import { Cartesian3, CustomDataSource, Color, Entity, PropertyBag, Billboard, BillboardCollection } from 'cesium';
import { jobs } from '../Resume/Experience.tsx';
export function createJobSource(): CustomDataSource {
        let jobSource = new CustomDataSource();
        let locations = new Map<string, Entity>();
        for (const job of jobs) {
            for (const address of job.addresses) {
                let key = JSON.stringify(address.coords);
                if (locations.has(key)) {
                    (locations.get(key) as any).jobs.push(job);
                    continue;
                }

                const img = new Image();
                img.src = job.logoImg;
                let ent = jobSource.entities.add({
                    point: {
                        color: Color.WHITE,
                        pixelSize: 10,
                        outlineColor: Color.WHITE,
                        outlineWidth: 2,
                    },
                    position: Cartesian3.fromDegrees(address.coords.lon, address.coords.lat),
                    properties: new PropertyBag(),
                });
                let jobArray = [job];
                ent.addProperty("jobs");
                (ent as any).jobs = jobArray;
                locations.set(key, ent);
                img.onload = () => {
                    const ar = img.naturalWidth / img.naturalHeight;
                    const height = 30;
                    const width = height * ar;
                    ent.billboard = new Billboard({
                        image: job.logoImg,
                        height,
                        width,
                        verticalOrigin: 1,
                    } as Billboard.ConstructorOptions, new BillboardCollection()) as any;
                }
            }
        }
        return jobSource;
}
